/**
 * Deep links from Credential Health into IP Activity, pre-filtered to the same
 * population over the same window a card describes — so the rows a customer
 * lands on are exactly the ones the number counted.
 */

const SORT = "sort_by=fraud_score&sort_order=desc";

/** Failed 2FA from sources that never sign in successfully (the hostile headline). */
export const HOSTILE_SECOND_FACTOR_FILTER =
  "has_failures=with&has_successful_auth=without&has_failed_second_factor=with";

/** Failed 2FA from sources that also sign in normally (the exclusion note). */
export const TRUSTED_SECOND_FACTOR_FILTER = "has_successful_auth=with&has_failed_second_factor=with";

// Computed in UTC to line up with the backend cutoff (datetime.now(UTC) - window);
// a local date could shift the window by a day at the timezone boundary.
export function windowStartDate(windowDays: number): string {
  return new Date(Date.now() - windowDays * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function ipActivityLink(windowDays: number, filter: string): string {
  return `/ip-activity?${filter}&start_date=${windowStartDate(windowDays)}&${SORT}`;
}

export function ipActivityIpLink(windowDays: number, ip: string): string {
  return `/ip-activity?ip_search=${encodeURIComponent(ip)}&start_date=${windowStartDate(windowDays)}`;
}
